import { isBrowser } from '@/utils/browser';

const STORAGE_KEY = `vsly_pins_tab_badge_count`;
const BADGE_CHANGE_EVENT = `vsly-pins-tab-badge-changed`;

function readCount(): number {
  if (!isBrowser()) return 0;
  const raw = window.localStorage.getItem(STORAGE_KEY);
  const parsed = raw ? parseInt(raw, 10) : 0;
  return Number.isNaN(parsed) ? 0 : parsed;
}

function writeCount(count: number) {
  if (!isBrowser()) return;
  window.localStorage.setItem(STORAGE_KEY, `${count}`);
  window.dispatchEvent(
    new CustomEvent<number>(BADGE_CHANGE_EVENT, { detail: count }),
  );
}

export function getPinsTabBadgeCount(): number {
  return readCount();
}

export function incrementPinsTabBadgeCount(): number {
  const next = readCount() + 1;
  writeCount(next);
  return next;
}

export function resetPinsTabBadgeCount(): void {
  if (readCount() === 0) return;
  writeCount(0);
}

export function subscribeToPinsTabBadgeCount(
  callback: (count: number) => void,
): () => void {
  const noop = () => undefined;
  if (!isBrowser()) return noop;

  const onChange = (ev: Event) => {
    callback((ev as CustomEvent<number>).detail);
  };

  window.addEventListener(BADGE_CHANGE_EVENT, onChange);
  return () => window.removeEventListener(BADGE_CHANGE_EVENT, onChange);
}
